import {ImportingDataTypes} from "../../types";
import {createInvalidExternalPartSection, PreventionInvalidityCode} from "./shared";

/**
 * Preventative correction config for external products import.
 */
export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.externalProducts,
    sections: [
        {
            sectionKey: "missingExternalProductFields",
            sectionTitle: "Missing Part Number or Internal ID",
            invalidityCode: PreventionInvalidityCode.MISSING_REQUIRED_FIELDS,
            fields: [
                createInvalidExternalPartSection("partNumber").fields[0],
                {
                    key: "internalId",
                    label: "Internal ID",
                    type: "input",
                    modifyRow: (row, val) => ({...row, internalId: val}),
                },
            ],
        },
    ],
};
